function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icons / Heart"
}, /*#__PURE__*/React.createElement("g", {
  id: "Vector",
  filter: "url(#filter0_d_1500_2236)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.8615 6.61251C28.2277 5.97838 27.4751 5.47535 26.6468 5.13215C25.8185 4.78895 24.9308 4.6123 24.0342 4.6123C23.1376 4.6123 22.2498 4.78895 21.4215 5.13215C20.5932 5.47535 19.8407 5.97838 19.2069 6.61251L17.8915 7.92792L16.576 6.61251C15.2958 5.33222 13.5593 4.61297 11.7487 4.61297C9.93813 4.61297 8.2017 5.33222 6.92141 6.61251C5.64113 7.89279 4.92188 9.62923 4.92188 11.4398C4.92187 13.2504 5.64113 14.9868 6.92141 16.2671L8.23682 17.5825L17.8915 27.2372L27.5461 17.5825L28.8615 16.2671C29.4956 15.6333 29.9986 14.8808 30.3418 14.0525C30.685 13.2242 30.8617 12.3364 30.8617 11.4398C30.8617 10.5432 30.685 9.65546 30.3418 8.82717C29.9986 7.99888 29.4956 7.24633 28.8615 6.61251Z",
  fill: "#2C2C2C",
  fillOpacity: 0.6,
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.8615 6.61251C28.2277 5.97838 27.4751 5.47535 26.6468 5.13215C25.8185 4.78895 24.9308 4.6123 24.0342 4.6123C23.1376 4.6123 22.2498 4.78895 21.4215 5.13215C20.5932 5.47535 19.8407 5.97838 19.2069 6.61251L17.8915 7.92792L16.576 6.61251C15.2958 5.33222 13.5593 4.61297 11.7487 4.61297C9.93813 4.61297 8.2017 5.33222 6.92141 6.61251C5.64113 7.89279 4.92188 9.62923 4.92188 11.4398C4.92187 13.2504 5.64113 14.9868 6.92141 16.2671L8.23682 17.5825L17.8915 27.2372L27.5461 17.5825L28.8615 16.2671C29.4956 15.6333 29.9986 14.8808 30.3418 14.0525C30.685 13.2242 30.8617 12.3364 30.8617 11.4398C30.8617 10.5432 30.685 9.65546 30.3418 8.82717C29.9986 7.99888 29.4956 7.24633 28.8615 6.61251Z",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  shapeRendering: "crispEdges"
})));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_1500_2236",
  x: 0.421875,
  y: 4.1123,
  width: 34.9395,
  height: 31.625,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1500_2236"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1500_2236",
  result: "shape"
})));

function SvgWishList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishList);
export default __webpack_public_path__ + "static/media/wishList.c0d46435601cf19e07f34f8dc63f0cf6.svg";
export { ForwardRef as ReactComponent };